import { useTranslation } from 'hooks';
import { LineChartData } from 'reducers/home';
import { LineChartView } from './LineChartView';
import { Skeleton } from 'components/ui/skeleton';
import Button from 'components/ui/button';

interface Props {
  data?: LineChartData;
  isLoading: boolean;
  isError: boolean;
  onFetch: () => void;
}

export const LineChart: React.FC<Props> = ({
  data,
  isLoading,
  isError,
  onFetch,
}) => {
  const getTranslate = useTranslation();

  if (!data || isLoading || isError) {
    return (
      <>
        <div className='flex justify-between items-center'>
          <Skeleton height={14} width='40%' />
          {isError ? (
            <Button
              id='refresh'
              status='light'
              icon='im-Refill'
              iconSize={14}
              iconPosition='left'
              text='Refresh'
              onClick={onFetch}
            />
          ) : null}
        </div>
        <div className='flex gap-8'>
          <div style={{ maxWidth: 162, width: '100%' }}>
            <div className='w-full flex items-center gap-2 mb-1'>
              <Skeleton height={27} width={56} />
              <Skeleton height={27} width={32} />
            </div>
            <Skeleton height={17} width='100%' />
          </div>
          <div style={{ maxWidth: 162, width: '100%' }}>
            <div className='w-full flex items-center gap-2 mb-1'>
              <Skeleton height={27} width={56} />
              <Skeleton height={27} width={32} />
            </div>
            <Skeleton height={17} width='100%' />
          </div>
        </div>
        <Skeleton height={140} />
      </>
    );
  }

  return (
    <>
      <h5 className='text-l-medium'>{getTranslate(data.title)}</h5>
      <LineChartView data={data} />
    </>
  );
};
